if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');
          button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          
          // Prefetch image on hover
          button.addEventListener('mouseenter', () => {
            this.prefetchImage(mediaToSwitch.dataset.target);
          }, { once: true });
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        
        // CARICA TUTTE LE IMMAGINI IMMEDIATAMENTE
        this.preloadImages();
      }

      preloadImages() {
        // CARICA TUTTE LE IMMAGINI IMMEDIATAMENTE - NESSUN LIMITE
        const mediaItems = this.elements.viewer.querySelectorAll('[data-media-id] img');
        
        // Forza TUTTE le immagini a caricare immediatamente
        mediaItems.forEach((img) => {
          // Rimuovi lazy loading
          if (img.loading === 'lazy') {
            img.loading = 'eager';
          }
          
          // Force decode immediato
          if (img.decode && !img.dataset.decoded) {
            img.decode().then(() => {
              img.dataset.decoded = 'true';
            }).catch(() => {});
          }
          
          // Forza il browser a iniziare il download immediatamente
          const tempImg = new Image();
          tempImg.decoding = 'async';
          tempImg.src = img.currentSrc || img.src;
          
          // Precarica anche tutte le varianti srcset
          if (img.srcset) {
            const srcsetUrls = img.srcset.split(',').map(s => s.trim().split(' ')[0]);
            srcsetUrls.forEach(url => {
              const preloadImg = new Image();
              preloadImg.decoding = 'async';
              preloadImg.src = url;
            });
          }
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        
        // Force eager loading of the target image
        const targetImg = activeMedia.querySelector('img');
        if (targetImg && targetImg.loading === 'lazy') {
          targetImg.loading = 'eager';
        }
        
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        
        // Use requestAnimationFrame for smoother transition
        requestAnimationFrame(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'instant' });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        
        this.playActiveMedia(activeMedia);
        
        // Preload adjacent images
        this.preloadAdjacentImages(mediaId);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      preloadAdjacentImages(currentMediaId) {
        const allMedia = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        const currentIndex = allMedia.findIndex(media => media.dataset.mediaId === currentMediaId);
        
        // Preload next 3 and previous 2 images (more aggressive)
        [-2, -1, 1, 2, 3].forEach(offset => {
          const adjacentIndex = currentIndex + offset;
          if (adjacentIndex >= 0 && adjacentIndex < allMedia.length) {
            const adjacentMedia = allMedia[adjacentIndex];
            const adjacentImg = adjacentMedia.querySelector('img');
            
            if (adjacentImg) {
              if (adjacentImg.loading === 'lazy') {
                adjacentImg.loading = 'eager';
              }
              
              // Force immediate decode and cache
              const tempImg = new Image();
              tempImg.decoding = 'async';
              tempImg.src = adjacentImg.currentSrc || adjacentImg.src;
              
              // Also decode the actual image
              if (adjacentImg.decode) {
                adjacentImg.decode().catch(() => {});
              }
            }
          }
        });
      }

      prefetchImage(mediaId) {
        // Questo metodo non è più necessario perché tutte le immagini
        // sono già precaricate, ma lo manteniamo per sicurezza
        const media = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!media) return;
        
        const img = media.querySelector('img');
        if (img && img.decode && !img.dataset.decoded) {
          img.decode().then(() => {
            img.dataset.decoded = 'true';
          }).catch(() => {});
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
